import React from "react";
import { Check, Phone, Mail, Calendar, ArrowLeft, Sparkles } from "lucide-react";

export default function ThankYou({ booking, onBack }) {
  const name = booking?.name || "";
  const first = name.split(" ")[0] || "there";

  return (
    <div
      data-testid="thank-you-page"
      className="min-h-screen w-full bg-[color:var(--bg)] grain relative overflow-hidden"
    >
      {/* Decorative gradient blob */}
      <div className="absolute -top-24 -right-24 w-[600px] h-[600px] rounded-full bg-[color:var(--accent)]/10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-24 -left-24 w-[500px] h-[500px] rounded-full bg-[color:var(--accent)]/15 blur-3xl pointer-events-none" />

      <div className="relative max-w-[1100px] mx-auto px-6 md:px-10 py-16 md:py-24 min-h-screen flex flex-col justify-center">
        <div className="flex items-center gap-3 mb-8">
          <span className="diamond-divider" />
          <span className="overline">Deluxe Diamond Detailing</span>
        </div>

        <div className="inline-flex items-center justify-center w-16 h-16 bg-[color:var(--primary)] text-white rounded-full mb-8 shadow-lg">
          <Check size={28} strokeWidth={2.5} />
        </div>

        <h1 className="font-display font-light tracking-tighter text-neutral-900 text-5xl md:text-6xl lg:text-7xl leading-[0.95] max-w-3xl">
          Thank you, {first}.
          <br />
          <span className="metallic-text font-bold">Your booking is in.</span>
        </h1>

        <p className="mt-8 text-neutral-600 text-lg md:text-xl leading-relaxed max-w-2xl">
          We&apos;ve received your request and one of our detailers will reach
          out shortly with a confirmation text to lock in your appointment. In
          the meantime, keep an eye on your messages{" "}
          <Sparkles size={16} className="inline text-[color:var(--accent)]" />
        </p>

        {booking?.service && (
          <div className="mt-10 card p-6 max-w-2xl rounded-sm">
            <div className="overline mb-4">Your request</div>
            <dl className="grid grid-cols-1 sm:grid-cols-3 gap-5 text-sm">
              <div>
                <dt className="text-neutral-500 text-xs uppercase tracking-wider mb-1">Service</dt>
                <dd className="font-display font-semibold text-neutral-900">
                  {booking.service.split(" — ")[0]}
                </dd>
              </div>
              <div>
                <dt className="text-neutral-500 text-xs uppercase tracking-wider mb-1">Preferred date</dt>
                <dd className="font-display font-semibold text-neutral-900">
                  {booking.preferred_date}
                  {booking.preferred_time ? ` · ${booking.preferred_time}` : ""}
                </dd>
              </div>
              <div>
                <dt className="text-neutral-500 text-xs uppercase tracking-wider mb-1">Confirmation</dt>
                <dd className="font-display font-semibold text-neutral-900">
                  Via SMS shortly
                </dd>
              </div>
            </dl>
          </div>
        )}

        <div className="mt-10 flex flex-wrap gap-3">
          <a
            href="tel:0450539879"
            data-testid="thank-you-call"
            className="btn-primary"
          >
            <Phone size={16} /> 0450 539 879
          </a>
          <a
            href="mailto:deluxe.diamond.detailing0@gmail.com"
            data-testid="thank-you-email"
            className="btn-ghost"
          >
            <Mail size={16} /> Email us
          </a>
          <button
            onClick={onBack}
            data-testid="thank-you-back"
            className="btn-ghost"
          >
            <ArrowLeft size={16} /> Back to site
          </button>
        </div>

        <p className="mt-12 text-xs text-neutral-400 italic">
          Precision. Protection. Perfection.
        </p>
      </div>
    </div>
  );
}
